'use client';
import React from 'react';
import { useLeague } from '@/hooks/useLeague';
import { useRanking } from '@/hooks/useRanking';
import { HOT_LEAGUES, TAB_LABELS } from '@/constants';
import { LeagueSelector } from './LeagueSelector';
import { RankingTable } from './RankingTable';
import { RankingTabs } from './RankingTabs';
import LoadingInner from '../Loading';

export const BangXepHangPage = () => {
  const { hotLeagues, isLoadingHot, selectLeague: selectLeagueInRedux } = useLeague();

  const leagues = hotLeagues.length > 0 ? hotLeagues : HOT_LEAGUES;

  const {
    currentLeagueId,
    standings,
    currentData,
    loading: rankingLoading,
    error: rankingError,
    activeTab,
    availableTabs,
    selectLeague,
    changeTab,
  } = useRanking({
    leagues,
    onLeagueChange: selectLeagueInRedux,
  });

  const currentLeague = leagues.find(l => l.id === currentLeagueId);

  return (
    <div className="w-full  min-h-screen">
      <div className="px-2 py-3">
        
          <LeagueSelector
            leagues={leagues}
            selectedLeagueId={currentLeagueId}
            onLeagueChange={selectLeague}
            isLoading={isLoadingHot}
          />
        

        {rankingLoading && (
          <LoadingInner />
        )}

        {rankingError && !rankingLoading && (
          <div className="bg-[var(--theme-foreground)] border border-[var(--theme-border)] rounded-lg p-6">
            <div className="flex items-center gap-3">
              <svg
                className="w-6 h-6 text-[var(--theme-primary)]"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <p className="text-[var(--theme-primary)]">{rankingError}</p>
            </div>
          </div>
        )}

        {!rankingLoading && !rankingError && standings && (
          <div className="bg-[var(--theme-bg)] rounded-lg shadow-lg overflow-hidden">
            {availableTabs.length > 0 && (
              <RankingTabs
                tabs={availableTabs}
                activeTab={activeTab}
                onTabChange={changeTab}
                tabLabels={TAB_LABELS}
              />
            )}

              <RankingTable
                data={currentData}
                league={standings.league || currentLeague}
                showLast5Matches={activeTab === 'totalStandings'}
                groupName={!['totalStandings', 'homeStandings', 'awayStandings', 'halfStandings'].includes(activeTab) ? activeTab : null}
              />
            
          </div>
        )}

        {!rankingLoading && !rankingError && !currentLeagueId && (
          <div className="flex flex-col items-center justify-center py-16 bg-[var(--theme-foreground)] rounded-lg">
            <svg
              className="w-16 h-16 mb-4 text-[var(--theme-text-muted)]"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
              />
            </svg>
            <p className="text-lg font-medium text-gray-700 dark:text-gray-300">
              Chưa có dữ liệu bảng xếp hạng
            </p>
            <p className="text-sm mt-1 text-[var(--theme-text-muted)]">
              Vui lòng chọn giải đấu để xem
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
